import { SVGProps } from 'react';

export default function DoubleChevronDown(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      {...props}>
      <path
        d="M14.2621 12.2784C14.0874 12.4485 14 12.665 14 12.9279C14 13.1908 14.0874 13.4073 14.2621 13.5775L18.6458 17.8459C18.7411 17.9387 18.8444 18.0045 18.9556 18.0435C19.0667 18.0819 19.1859 18.101 19.3129 18.101C19.44 18.101 19.5591 18.0819 19.6703 18.0435C19.7815 18.0045 19.8847 17.9387 19.98 17.8459L24.3876 13.5543C24.5623 13.3841 24.6497 13.1754 24.6497 12.9279C24.6497 12.6805 24.5544 12.464 24.3638 12.2784C24.1891 12.1083 23.9667 12.0232 23.6967 12.0232C23.4267 12.0232 23.2043 12.1083 23.0296 12.2784L19.3129 15.8972L15.5724 12.2552C15.3977 12.0851 15.1833 12 14.9292 12C14.675 12 14.4527 12.0928 14.2621 12.2784Z"
        fill="white"
      />
      <path
        d="M14.2621 20.3795C14.0874 20.5496 14 20.7661 14 21.029C14 21.2919 14.0874 21.5084 14.2621 21.6785L18.6458 25.9469C18.7411 26.0397 18.8444 26.1056 18.9556 26.1446C19.0667 26.1829 19.1859 26.2021 19.3129 26.2021C19.44 26.2021 19.5591 26.1829 19.6703 26.1446C19.7815 26.1056 19.8847 26.0397 19.98 25.9469L24.3876 21.6553C24.5623 21.4852 24.6497 21.2764 24.6497 21.029C24.6497 20.7815 24.5544 20.565 24.3638 20.3795C24.1891 20.2093 23.9667 20.1243 23.6967 20.1243C23.4267 20.1243 23.2043 20.2093 23.0296 20.3795L19.3129 23.9983L15.5724 20.3563C15.3977 20.1861 15.1833 20.1011 14.9292 20.1011C14.675 20.1011 14.4527 20.1939 14.2621 20.3795Z"
        fill="white"
      />
    </svg>
  );
}
